function getUserLocation() {
  var userRegion
  var userCity
  var userCountry
  var userTimeZone
  var mapTimezoneToCountry

  userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const tzArr = userTimeZone.split('/')
  userRegion = tzArr[0]
  userCity = tzArr[tzArr.length - 1]

  if (userCity === 'Bratislava') {
    $('.js-apollo').attr('href', 'https://doplnky.shoptet.sk/sablona-apollo')
    $('.js-apollo-rating').attr(
      'href',
      'https://doplnky.shoptet.sk/sablona-apollo#section-ratings',
    )

    $('.js-addon-hodnotenie').attr(
      'href',
      'https://doplnky.shoptet.sk/banner-hodnotenie',
    )

    $('.js-addon-prihlaseni').attr(
      'href',
      'https://doplnky.shoptet.sk/cena-po-prihlaseni',
    )

    $('.js-addon-kontakt').attr(
      'href',
      'https://doplnky.shoptet.sk/banner-kontakt',
    )

    $('.js-addon-detail-infohlaska').attr(
      'href',
      'https://doplnky.shoptet.sk/infohlaska-v-detaile',
    )

    $('.js-addon-sipky').attr('href', 'https://doplnky.shoptet.sk/sipky')

    $('.js-addon-stitok').attr(
      'href',
      'https://doplnky.shoptet.sk/stitok-akcia',
    )

    $('.js-addon-klik').attr('href', 'https://doplnky.shoptet.sk/banner-klik')

    $('.js-addon-zalozka-infohlaska').attr(
      'href',
      'https://doplnky.shoptet.sk/infohlaska-na-zalozke',
    )

    $('.js-addon-top-kategorie').attr(
      'href',
      'https://doplnky.shoptet.sk/top-kategorie',
    )

    $('.js-addon-tlacidla').attr(
      'href',
      'https://doplnky.shoptet.sk/uprava-tlacidiel',
    )

    $('.js-addon-base').attr('href', 'https://doplnky.shoptet.sk/')

    $('.js-addon-all').attr(
      'href',
      'https://doplnky.shoptet.sk/katalog?partner=198',
    )

    $('.js-shoptet-partner').attr(
      'href',
      'https://partneri.shoptet.cz/?utm_source=partners_affiliate&utm_medium=link&utm_content=wp_id_8113&utm_campaign=SVK_PAR_AFF_11_ACQ_DO_8113',
    )

    $('.js-shoptet-tursky').attr(
      'href',
      'https://partneri.shoptet.sk/profesionali/jakub-tursky/',
    )

    $('.js-shoptet-webinar').attr(
      'href',
      'https://partneri.shoptet.sk/webinare',
    )
  }
}
